import { Modal, Button as AntButton } from "antd";
import { FC, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import useNotification from "../../../../../hooks/useNotification";
import { IStudent } from '../../../../../models/students.model';
import { IStudentBreakdown } from "../../../../../models/payments.model";
import { updatePaymentByCoupon } from "../../../../../api/payments.api";
import useAxios from "../../../../../hooks/useAxios";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  student?: IStudent;
  paymentRecord?: IStudentBreakdown;
  setPaymentRecord: (paymentRecord: undefined) => void;
  couponDelete: boolean;
  setCouponDelete: (couponDelete: boolean) => void;
};

const CouponDeleteModal: FC<IProps> = ({
  visible,
  setVisible,
  student,
  paymentRecord,
  setPaymentRecord,
  couponDelete,
  setCouponDelete,
}) => {
  const { t } = useTranslation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  useEffect(() => {
    if (res) {
      successNotification(t('student.student.message58'));
      setVisible(false);
      setCouponDelete(true);
    }
  }, [res]);
  
  const onSubmit = () => {
    const code = paymentRecord?.paymentRecordCode || 0;
    execute(updatePaymentByCoupon(code));
    // eslint-disable-next-line no-restricted-globals
    //location.reload()
  };

  return (
    <>
      <Modal
        title={t('student.student.button27')}
        visible={visible}
        onCancel={() => setVisible(false)}
        width={350}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton key="submit" className='btn-basic pink' onClick={() => onSubmit()}>
              {t('common.button.confirm')}
            </AntButton>
            <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <p className="align-self-center">{t('system.menu.text3')}</p>
      </Modal>
    </>
  );
};

export default CouponDeleteModal;